import { KontableNewComponent } from './../../../../modules/UIKit/components/kontablenew/kontablenew.component';
import { VoucherCouponService } from 'app/services/voucher-coupon-mg/voucher-coupon.service';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-web-log',
  templateUrl: './web-log.component.html',
  styleUrls: ['./web-log.component.css']
})
export class WebLogComponent implements OnInit {

  @Input() couponVoucherId: string;  

  paginationType_Log = KontableNewComponent.ServerPagination;  
  paginationType_WebLog = KontableNewComponent.ServerPagination;  

  show = {
    webLog: false,
    log: false
  }

  initialFilters = {
    log: new Array<{key: string, value: any}>(),
    webLog: new Array<{key: string, value: any}>()
  }

  methodsNames = {
    log: { list: 'getWebLog_Log', sendExtSearchQuery: 'sendExtSearchQuery' },
    webLog: { list: 'getWebLog_WebLog', sendExtSearchQuery: 'sendExtSearchQuery' }
  }

  constructor(
    private srvVoucherCoupon: VoucherCouponService
  ) { }

  ngOnInit() {    
    this.initialFilters.log.push({key: "voucherId", value: this.couponVoucherId});
    this.initialFilters.webLog.push({key: "voucherId", value: this.couponVoucherId});
    this.show.log = true;
    this.show.webLog = true;
  }
  getDateTime(dateTime:string): string{
    let res = "";
    if(dateTime && dateTime.length > 0){
      res = dateTime.substr(8,2) + "/" + dateTime.substr(5,2) + "/" + dateTime.substr(0,4) + " " + dateTime.substr(11,8);
    }
    return res;
  }  
}



// WEBPACK FOOTER //
// ./src/app/views/voucher-coupon-mg/voucher-coupon-mg-detail/web-log/web-log.component.ts